import { render, staticRenderFns } from "./DTableSearch.vue?vue&type=template&id=5393c90a&scoped=true&"
import script from "./DTableSearch.vue?vue&type=script&lang=js&"
export * from "./DTableSearch.vue?vue&type=script&lang=js&"
import style0 from "./DTableSearch.vue?vue&type=style&index=0&id=5393c90a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393c90a",
  null
  
)

export default component.exports